module.exports = __webpack_public_path__ + "img/digital_payment_device_dollar.4d21cbad.svg";